<template>
    <rkm-area
        background-color="primary"
        closed
        header-prefix-icon="vial"
        title="Exames"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.exames"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">

                        <rkm-row>
                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.tipo"
                                    label="Tipo do exame"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.descricao"
                                    label="Descrição do exame"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'
// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        Item,
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        item: {type: Object, required: true},
    },
}
</script>